"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.opDetailsAPI = exports.emailAPI = exports.stripeAPI = exports.subscriptionAPI = exports.companyAPI = exports.turvoAPI = exports.oppenheimerAPI = exports.postsAPI = exports.authAPI = void 0;
const formatAPIRoute_1 = __importDefault(require("../utils/formatAPIRoute"));
exports.authAPI = (0, formatAPIRoute_1.default)("/auth" /* API_ROUTE.AUTH */);
exports.postsAPI = (0, formatAPIRoute_1.default)("/posts" /* API_ROUTE.POSTS */);
exports.oppenheimerAPI = (0, formatAPIRoute_1.default)("/oppenheimer" /* API_ROUTE.OPPENHEIMER */);
exports.turvoAPI = (0, formatAPIRoute_1.default)("/integration" /* API_ROUTE.INTEGRATION */);
exports.companyAPI = (0, formatAPIRoute_1.default)("/company" /* API_ROUTE.COMPANY */);
exports.subscriptionAPI = (0, formatAPIRoute_1.default)("/subscription" /* API_ROUTE.SUBSCRIPTION */);
exports.stripeAPI = (0, formatAPIRoute_1.default)("/stripe" /* API_ROUTE.STRIPE */);
exports.emailAPI = (0, formatAPIRoute_1.default)("/mails" /* API_ROUTE.EMAIL */);
exports.opDetailsAPI = (0, formatAPIRoute_1.default)("/opdetails" /* API_ROUTE.OPDETAILS */);
